import { useMemo } from "react";

import { useAppSelector } from "@/redux/hooks";
import { authSelector } from "@/pages/Public/redux/auth.slice";

import { useHasPermissions } from "@/utils/useHasPermissions";

import { useGetFeaturesQuery } from "@/pages/Private/redux/feature/feature.api";

import { CATALOG, CatalogEntry } from "../constants/catalog";

export const useVisibleCatalogEntries = (): CatalogEntry[] => {
	const { user } = useAppSelector(authSelector);
	const { data: features, isLoading } = useGetFeaturesQuery();
	const { hasPermissions } = useHasPermissions();

	return useMemo(() => {
		if (isLoading) {
			return [];
		}

		return CATALOG.filter((entry) => {
			if (entry.id === "lemlist" && !user?.company?.hasLemlistApiKey) {
				return false;
			}

			if (entry.feature) {
				const feature = features?.find((f) => f.feature === entry.feature);

				if (!feature?.active) {
					return false;
				}
			}

			if (entry.permission && !hasPermissions([entry.permission])) {
				return false;
			}

			return true;
		});
	}, [features, isLoading, user?.company?.hasLemlistApiKey, hasPermissions]);
};
